import { mix, observable, watch } from "@chorda/core";
import { Field } from "chorda-bulma";
import { FieldIcons } from "../form/field/with-icon";
import { withMix } from "../utils";
import { Dropdown, DropdownTrigger } from "./Dropdown";
import { TextInput } from "./TextInput";
export const DropdownInput = (props) => {
    return mix(Dropdown(props), {
        templates: {
            trigger: withMix(false, DropdownTrigger({
                content: Field({
                    control: TextInput({
                        value$: $ => $.$context.value,
                        onFocus: (e, { focused }) => {
                            focused.$value = true;
                        },
                        onBlur: (e, { focused }) => {
                            focused.$value = false;
                        },
                    }),
                }),
            }))
        },
    }, props && {
        templates: {
            trigger: withMix(DropdownTrigger({
                content: Field({
                    control: TextInput({
                        as: props.inputAs
                    }),
                    as: FieldIcons({
                        rightIcon: props.icon
                    })
                }),
            }), props.trigger)
        },
        defaults: {
            focused: () => observable(false)
        },
        joints: {
            autoActivate: ({ active, items, focused }) => {
                watch(() => {
                    //                        console.log(items.length, focused.$value)
                    active.$value = items.length > 1 && focused.$value;
                }, [items, focused]);
            }
        }
    });
};
